import actions from '../../actionTypes';

export default site => {
  return {
    type: actions.ADD_SITE,
    site
  };
};



// WEBPACK FOOTER //
// ./src/reducers/sites/actions/siteAdd.js